import React from "react";
import SAEventOverview from "./SAEventOverview";
import SARiyadhSection from "./SARiyadhSection";
import SAEnablementSection from "./SAEnablementSection";
import SATransformationAreasSection from "./SATransformationAreasSection";
import SAStatisticsSection from "./SAStatisticsSection";
import SAWhoWhyAttendSection from "./SAWhoWhyAttendSection";
import SAClosingVisionSection from "./SAClosingVisionSection";
import { darkSectionBg } from "../darkSectionTokens";

function SAConferenceSections() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;
  const bg = require("assets/images/green-grunge-paper-background.jpg");

  return (
    <div
      id="about"
      className="section section-with-space pt-0 pb-0"
      style={darkSectionBg(bg, size)}
      data-parallax={true}
    >
      <SAEventOverview />
      <SARiyadhSection />
      <SAEnablementSection />
      <SATransformationAreasSection />
      <SAStatisticsSection />
      <SAWhoWhyAttendSection />
      <SAClosingVisionSection />
    </div>
  );
}

export default SAConferenceSections;
